<div class="item-status" [ngClass]="{'item-status--disabled': status !== true && status !== false, 'item-status--checked': status === true, 'item-status--alert': status === false}">
    <div class="item-status__content">
        <div class="item-status__status" *ngIf="status === true || status === false" [ngClass]="{'item-status__status--checked': status === true, 'item-status__status--alert': status === false}">
            <vwui-icon *ngIf="status === true" iconName="vwui-check"></vwui-icon>
            <vwui-icon *ngIf="status === false" iconName="alert"></vwui-icon>
        </div>
        <ng-content></ng-content>
    </div>
</div>
